import { Routes } from "@/router/routes";
import { RouteObject } from "react-router";
import { Users } from "./users";
import { InviteUser } from "./components/invite-user/invite-user";
import { UsersTable } from "./pages/users-table/users-table";
import { Roles } from "./pages/roles/roles";
import { UserEdit } from "./pages/users-table/pages/user-edit/user-edit";

export const usersRouterConfig: RouteObject[] = [
    {
        path: Routes.Users,
        element: <Users />,
        children: [
            {
                path: "",
                element: <UsersTable />,
                children: [
                    {
                        path: ":userId/edit",
                        element: <UserEdit />,
                    },
                    {
                        path: "invite",
                        element: <InviteUser />,
                    },
                ],
            },
            {
                path: "roles",
                element: <Roles />,
            },
        ],
    },
];
